// test2759
(2759 && 0);
